<div class="container">
  <div class="container__section container__section_test"
    *ngIf="!environment.production"
  >
    <app-form-test-buttons
      (stepChange)="stepChange.emit($event)"
      (customerInfoChange)="fillCustomerInfo($event)"
      (shippingAddressChange)="
        formShippingAddressComponent.active = false;
        formShippingAddressComponent.formGroup.setValue($event);
      "
      (paymentDataChange)="formPayment = $event"
    ></app-form-test-buttons>
  </div>
  <div class="container__section container__section_summary"
    *ngIf="summaryShow"
  >
    <app-section-summary>
      <app-section-summary-item
        *ngIf="summaryEmail"
        [key]="SUMMARY.email"
        [value]="summaryEmail"
        (change)="summaryOnChange($event)"
      ></app-section-summary-item>
      <app-section-summary-item
        *ngIf="summaryAddress"
        [key]="SUMMARY.address"
        [value]="summaryAddress"
        (change)="summaryOnChange($event)"
      ></app-section-summary-item>
      <app-section-summary-item
        *ngIf="summaryShippingAddress"
        [key]="SUMMARY.shippingAddress"
        [value]="summaryShippingAddress"
        (change)="summaryOnChange($event)"
      ></app-section-summary-item>
      <app-section-summary-item
        *ngIf="summaryShippingMethod"
        [key]="SUMMARY.shippingMethod"
        [value]="summaryShippingMethod"
        (change)="summaryOnChange($event)"
      ></app-section-summary-item>
    </app-section-summary>
  </div>
  <div class="container__section" [fxHide]="step !== 1">
    <app-form-customer-info
      [(data)]="formCustomerInfo"
      (dataChange)="onChange()"
    ></app-form-customer-info>
  </div>
  <div class="container__section" [fxHide]="step !== 1">
    <app-form-shipping-address
      [(active)]="formShippingAddressActive"
      (activeChange)="onChange()"
      [(data)]="formShippingAddress"
      (dataChange)="onChange()"
    ></app-form-shipping-address>
  </div>
  <div class="container__section" [fxHide]="step !== 2">
    <app-form-shipping-method
      [(shipping)]="formShippingMethod"
      [disabledShippingNames]="disabledShippingNames"
      [shippings]="shippings"
      (shippingChange)="onChange()"
    ></app-form-shipping-method>
  </div>
  <div class="container__section container__section_payment" [fxHide]="step !== 3">
    <app-form-payment
      [(data)]="formPayment"
      (dataChange)="onChange()"
      (submitButtonClick)="nextClick.emit()"
      [submitButtonDisabled]="isNextDisabled"
    ></app-form-payment>
  </div>
</div>
